/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'UserRenewals' store object.
 * @namespace UserRenewalsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAUserRenewals';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static fetchSdExternaluserRenewalStatus = state =>
    state[selectors.moduleIdentifier].fetchSdExternaluserRenewalStatus.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static isFetchingFetchSdExternaluserRenewalStatus = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdExternaluserRenewalStatus.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static fetchSdExternaluserRenewalStatusError = state =>
    state[selectors.moduleIdentifier].fetchSdExternaluserRenewalStatusError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static fetchSdRenewalApplicationForm = state =>
    state[selectors.moduleIdentifier].fetchSdRenewalApplicationForm.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static isFetchingFetchSdRenewalApplicationForm = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdRenewalApplicationForm.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static fetchSdRenewalApplicationFormError = state =>
    state[selectors.moduleIdentifier].fetchSdRenewalApplicationFormError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static fetchSdccaCcaRenewalApplicationForm = state =>
    state[selectors.moduleIdentifier].fetchSdccaCcaRenewalApplicationForm.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static isFetchingFetchSdccaCcaRenewalApplicationForm = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdccaCcaRenewalApplicationForm.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserRenewalsSelectors
   */
  static fetchSdccaCcaRenewalApplicationFormError = state =>
    state[selectors.moduleIdentifier].fetchSdccaCcaRenewalApplicationFormError.payload;
}
